import { FieldValues } from '@/constants'
import axios from 'axios'

export class PhotoApi {
  private m_instance: any

  public constructor() {
    this.m_instance = axios.create({
      // baseURL: 'https://api.prod.photos-presse.com/photo',
      baseURL: 'https://api.photos-presse.com/photo',
      timeout: 30000,
      // baseURL: 'https://ti8r5ptjte.execute-api.us-east-1.amazonaws.com/api'
    })
  }

  public updateBaseUrl(baseUrl: string): void {
    console.log('updateBaseUrl')

    this.m_instance.defaults.baseURL = baseUrl
  }

  public updateAuthorization(token: string): void {
    console.log('updateAuthorization')

    this.m_instance.defaults.headers.common['Authorization'] = token
  }

  public async getPhotosCounter(
    payload: Record<string, number>
  ): Promise<JSON> {
    console.log('getPhotosCounter', payload)

    return this.m_instance.post(`/counter`, payload)
  }

  public async getPhotoFromSearch(
    headers: any,
    payload: Record<string, number>
  ): Promise<JSON> {
    console.log('getPhotoFromSearch', headers, payload)

    if (headers) {
      const axiosConfiguration = {
        headers: headers
      }

      console.log('getPhotoFromSearch axiosConfiguration', axiosConfiguration)
      return this.m_instance.post(`/search`, payload, axiosConfiguration)
    } else {
      return this.m_instance.post(`/search`, payload)
    }
  }

  public async getPhotoFromSeason(
    payload: Record<string, number>
  ): Promise<JSON> {
    console.log('getPhotoFromSeason', payload)

    return this.m_instance.post(`/season`, payload)
  }

  public async getPhotoFromCategory(
    categoryId: number,
    payload: Record<string, number>
  ): Promise<JSON> {
    console.log('getPhotoFromCategory', payload)

    return this.m_instance.post(`/category/${categoryId}`, payload)
  }

  public async getPhotoFromSubCategory(
    subCategoryId: number,
    payload: Record<string, number>
  ): Promise<JSON> {
    console.log('getPhotoFromSubCategory', payload)

    return this.m_instance.post(`/sub_category/${subCategoryId}`, payload)
  }

  public async pullPhotos(
    payload: Record<string, string | number | boolean>
  ): Promise<JSON> {
    console.log('pullPhotos', payload)

    return this.m_instance.post('/pull', payload)
  }

  public async getPhotoValidation(
    payload: Record<string, string | number>
  ): Promise<JSON> {
    console.log('getPhotoValidation')

    return this.m_instance.post('/validation', payload)
  }

  public async getHome(): Promise<JSON> {
    console.log('getHome')

    return this.m_instance.get('/home')
  }

  public async delete(photoId: number): Promise<JSON> {
    console.log('delete')

    return this.m_instance.delete(`/${photoId}`)
  }

  public async update(
    photo_id: number,
    params: Record<string, any>
  ): Promise<JSON> {
    console.log('update')

    return this.m_instance.post(`/${photo_id}`, params)
  }

  public async validate(id: number): Promise<JSON> {
    console.log('validate')

    return this.m_instance.post(`/validation/${id}`)
  }

  public async getUploadHistory(paylod: Record<string, string>): Promise<JSON> {
    console.log('getUploadHistory')

    return this.m_instance.post('/upload_history', paylod)
  }

  public async multipleDelete(
    payload: Record<string, Array<number>>
  ): Promise<JSON> {
    console.log('multipleDelete', payload)

    return this.m_instance.delete('/multiple', { data: payload })
  }

  public async multipleValidation(
    payload: Record<string, Array<number>>
  ): Promise<JSON> {
    console.log('multipleValidation', payload)

    return this.m_instance.post('/multiple', payload)
  }

  public async multipleUpdate(
    payload: Record<string, Array<number> | Array<FieldValues>>
  ): Promise<JSON> {
    console.log('multipleUpdate')

    return this.m_instance.patch('/multiple', payload)
  }

  public async multipleDownload(
    payload: Record<string, Array<Record<string, string | number>>>
  ): Promise<JSON> {
    console.log('multipleDownload')

    return this.m_instance.post('/multiple/download', payload)
  }

  public async createHome(paylod: Record<string, number>): Promise<JSON> {
    console.log('createHome')

    return this.m_instance.post(`/home`, paylod)
  }

  public async deleteHome(id: number): Promise<JSON> {
    console.log('deleteHome')

    return this.m_instance.delete(`/home/${id}`)
  }

  public async updateHome(
    id: number,
    paylod: Record<string, number>
  ): Promise<JSON> {
    console.log('updateHome')

    return this.m_instance.patch(`/home/${id}`, paylod)
  }
}
